import { Button, Card, Center, Input, Modal, Stack, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import tangerineIcon from '../../assets/images/bridge-ad_logo_clear.png'
import useAuth from '../../hooks/api/useAuth'

function ForgotPassword() {
  const [opened, { open, close }] = useDisclosure(false)
  const [error, setError] = useState<string | null>('')
  const [email, setEmail] = useState<string>('')

  const { forgotPassword } = useAuth()

  const handleClick = () => {
    if (error) {
      return
    }
    forgotPassword(email)
      .catch(() => {})
      .finally(() => {
        open()
        setTimeout(() => {
          close()
        }, 5000)
      })
  }

  const checkEmail = () => {
    const regex = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/
    if (regex.test(email)) {
      setError(null)
    } else {
      setError('メールアドレスの形式が正しくありません')
    }
  }

  return (
    <Center w='100vw' h='100vh' bg='gray.0'>
      <Stack align='center'>
        <img src={tangerineIcon} alt='tangerine_icon' width={400} />
        <Card w='350px' shadow='sm' padding='40px' radius='md' withBorder>
          <Stack w='100%' align='center'>
            <Title order={3}>パスワード再設定</Title>
            <Input.Wrapper w='100%' label='メールアドレス' required error={error}>
              <Input type='email' value={email} onChange={(e) => setEmail(e.target.value)} onBlur={checkEmail} />
            </Input.Wrapper>
            <Button color='#00CC00' w='100%' mt={20} onClick={handleClick}>
              送信
            </Button>
            <Link to='/login' className='text-[#00CC00] font-semibold text-sm'>
              戻る
            </Link>
          </Stack>
        </Card>
      </Stack>
      <Modal opened={opened} onClose={close} withCloseButton={false} withOverlay={false}>
        <Card w={400}>
          <Stack w='100%' align='center'>
            <Title order={3} className='flex items-center'>
              <span className='material-icons text-green-500 mr-2'>check_circle</span>メールを送信しました
            </Title>
            <p>パスワード再設定の手順を以下のメールアドレスへ送信しました。</p>
            <p>{email}</p>
          </Stack>
        </Card>
      </Modal>
    </Center>
  )
}

export default ForgotPassword
